import { Button, Card, CardContent, FormControl, MenuItem, Select } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ReturnCommand } from '../../../../../services/command';
import { SCUIButton } from '../../../../../atomic/atoms';
import CloseIcon from '@mui/icons-material/Close';
import { UpdateReturnStatusReq } from './types';
import { createRequest } from './requestCreater';
import Helper from '../../../../../utils/helper';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

function ReturnStatusUpdate({ returnId, customerId, fromReturnStatusId, handleCloseChangeStatusModal }: any) {
    let storeCode: any = Helper.getStoreCode();
    const { t } = useTranslation();
    const [returnStatuses, setReturnStatuses] = useState([]);
    const [selectedState, setSelectedState] = useState('');

    const handleSave = () => {
        if (selectedState !== '') {
            Swal.fire({
                title: t('refund.processing'),
                html: t('orderDetail.statusUpdating'),
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
            const updateReturnStatusReq: UpdateReturnStatusReq = createRequest(
                selectedState,
                storeCode,
                customerId,
                returnId
            );
            ReturnCommand.ChangeReturnStatus(updateReturnStatusReq)
                .then((response: any) => {
                    if (response?.model?.result) {
                        handleCloseChangeStatusModal();
                        Swal.fire({
                            icon: 'success',
                            title: t('general.success'),
                            text: t('return.statusUpdateSuccess'),
                            timer: 1500,
                            showConfirmButton: true,
                        }).then(() => {
                            window.location.reload();
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Hata!',
                            text: t('return.statusUpdateError'),
                            showConfirmButton: true,
                        });
                    }
                })
                .catch(() => {
                    Swal.fire({
                        icon: 'error',
                        title: t('general.error'),
                        text: t('return.statusUpdateError'),
                        showConfirmButton: true,
                    });
                });
        } else {
            Swal.fire({
                icon: 'error',
                title: t('general.error'),
                text: t('refundList.selectStatus'),
                showConfirmButton: true,
            });
        }
    };
    useEffect(() => {
        ReturnCommand.GetReturnStatusChangeMatrixListWithRole({
            fromReturnStatusId,
        }).then((response: any) => {
            if (response != null && response.length > 0) {
                setReturnStatuses(response);
            } else {
                handleCloseChangeStatusModal();
                Swal.fire({
                    icon: 'error',
                    title: t('general.error'),
                    text: t('orderDetail.noStatusToTransition'),
                    showConfirmButton: true,
                });
            }
        });
    }, []);

    const handleSelectChange = (event: any) => {
        setSelectedState(event.target.value);
    };
    return (
        <>
            <Card variant="elevation" style={{ padding: '0.4rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <h2 style={{ marginLeft: '1.6rem', fontSize: '18px' }}>{t('return.updateReturnStatus')}</h2>
                    <Button onClick={handleCloseChangeStatusModal}>
                        <CloseIcon style={{ height: 'auto', color: 'black', width: '25px' }} />
                    </Button>
                </div>
                <CardContent>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <FormControl fullWidth style={{ marginBottom: '1rem', maxWidth: '300px' }}>
                            <Select
                                value={selectedState}
                                onChange={handleSelectChange}
                                displayEmpty
                                inputProps={{ 'aria-label': 'Without label' }}
                            >
                                <MenuItem value="" disabled>
                                    {t('general.chooseStatus')}
                                </MenuItem>
                                {returnStatuses &&
                                    returnStatuses.map((status: any, index: any) => (
                                        <MenuItem key={index} value={status.toStatusId}>
                                            {status.toStatusIdDescription}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                        <SCUIButton
                            style={{ maxWidth: '300px' }}
                            onClick={() => handleSave()}
                            type={'primary'}
                            sizeType={'fixed'}
                            size={'s'}
                            text={'Kaydet'}
                        ></SCUIButton>
                    </div>
                </CardContent>
            </Card>
        </>
    );
}

export default ReturnStatusUpdate;
